import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormGroup, ControlLabel, FormControl} from 'react-bootstrap';

class ControlledInput extends Component {
    static propTypes = {
        name: PropTypes.string,
        onChange: PropTypes.func.isRequired,
        validationState: PropTypes.string,
        value: PropTypes.string,
        label: PropTypes.string,
        placeholder: PropTypes.string,
        className: PropTypes.string
    };

    shouldComponentUpdate(nextProps) {
        return (
            nextProps.value !== this.props.value ||
            nextProps.validationState !== this.props.validationState
        );
    }

    render() {
        const {validationState, value, onChange, label, placeholder, name, className} = this.props;

        return (
            <FormGroup className={className} validationState={validationState}>
                <ControlLabel>{label}</ControlLabel>
                <FormControl
                    style={{fontSize: 16}}
                    name={name}
                    type="text"
                    value={value}
                    onChange={e => onChange(e.target.value)}
                    placeholder={placeholder}
                />
            </FormGroup>
        );
    }
}

export default ControlledInput;



// WEBPACK FOOTER //
// ./components/controlled_input/index.js